<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.98 8.24">
  <g>
    <polygon points="5.37 0 3.53 0 6.62 4.12 3.53 8.24 5.37 8.24 8.45 4.12 5.37 0" [attr.fill]="fillColor" />
    <polygon points="0 8.24 1.84 8.24 4.92 4.12 1.84 0 0 0 3.09 4.12 0 8.24" [attr.fill]="fillColor" />
    <polygon points="8.89 0 7.06 0 10.14 4.12 7.06 8.24 8.89 8.24 11.98 4.12 8.89 0" [attr.fill]="fillColor" />
  </g>
</svg>